import { Api } from '../api';

import { accounts } from '../endpoints';
import {
  BlockCardRequest,
  ChangeLimitRequest,
  GetAccountCardResponse,
  GetAccountLimitsResponse,
  RemindPinRequest,
  RequestSupplementRequest,
  GetAccountCardsResponse,
  GetAccountsCardsAccessResponse,
  GetCardExpirationsResponse,
  GetCardLimitsResponse,
} from './models';

export class AccountsApi extends Api {
  static getAccountCard = (itemType: string, itemId: string) => this.get<GetAccountCardResponse[]>({ url: accounts.getCards(itemType, itemId) });

  static getAccountLimits = (itemType: string, itemId: string) => this.get<GetAccountLimitsResponse>({ url: accounts.getLimits(itemType, itemId) });

  static blockCard = (request: BlockCardRequest) => this.post<BlockCardRequest, undefined>({ url: accounts.blockCard(), data: request });

  static changeLimit = (request: ChangeLimitRequest) => this.post<ChangeLimitRequest, undefined>({ url: accounts.changeLimit(), data: request });

  static remindPin = (request: RemindPinRequest) => this.post<RemindPinRequest, undefined>({ url: accounts.remindPin(), data: request });

  static requestSupplement = (request: RequestSupplementRequest) =>
    this.post<RequestSupplementRequest, undefined>({ url: accounts.requestSupplement(), data: request });

  static getAccountsCardsAccess = () => this.get<GetAccountsCardsAccessResponse[]>({ url: accounts.getAccountsCardsAccess() });

  static getAccountCards = (accountId: number) => this.get<GetAccountCardsResponse[]>({ url: accounts.getCards('Account', accountId) });

  static getCardInfo = (accountId: number) => this.get<GetAccountCardsResponse[]>({ url: accounts.getCards('Card', accountId) });

  static getAccountLimitsV2 = (accountId: number) => this.get<GetCardLimitsResponse>({ url: accounts.getLimits('Account', accountId) });

  static getCardLimits = (cardId: number) => this.get<GetCardLimitsResponse>({ url: accounts.getLimits('Card', cardId) });

  static getCardExpirations = (cardId: number) => this.get<GetCardExpirationsResponse>({ url: accounts.getExpirations('Card', cardId) });

  static getCardPhone = (cardId: number | string) => this.get<string>({ url: accounts.getCardPhone(cardId) });
}
